import InspirationCategoriesIcons from './InspirationCategoriesIcons';

export default InspirationCategoriesIcons;

export { default as NewOpenings } from './NewOpenings';
export { default as Families } from './Families';
export { default as Suitcase } from './Suitcase';
export { default as Snowflake } from './Snowflake';
export { default as Beach } from './Beach';
export { default as CountrySide } from './CountrySide';
export { default as Balloon } from './Balloon';
export { default as Gift } from './Gift';
export { default as Wellness } from './Wellness';
